import React, { useState, useEffect } from "react";
import cx from "classnames";

const Pagination = ({ page, setPage, totalPage, scrollToResultHeader }) => {
  const defaultShownPage = [1, 2, 3, 4, 5, "more", totalPage];
  const [shownPage, setShownPage] = useState(
    totalPage <= 7
      ? [...Array(totalPage)].map((_, i) => i + 1)
      : defaultShownPage
  );

  useEffect(() => {
    if (totalPage > 7) {
      if (page <= 3) {
        setShownPage(defaultShownPage);
      } else if (page >= totalPage - 2) {
        setShownPage([
          1,
          "more",
          totalPage - 4,
          totalPage - 3,
          totalPage - 2,
          totalPage - 1,
          totalPage,
        ]);
      } else if (page >= 4 && page <= totalPage - 2) {
        setShownPage([1, "more", page - 1, page, page + 1, "more", totalPage]);
      }
    } else {
      setShownPage([...Array(totalPage)].map((_, i) => i + 1));
    }
  }, [totalPage, page]);

  const Button = ({ className, goToPage, children }) => (
    <button
      className={className}
      onClick={() => {
        setPage(goToPage);
        scrollToResultHeader();
      }}
    >
      {children}
    </button>
  );

  return (
    <div className="page d-flex align-items-center">
      <Button className={cx("button", { invisible: page === 1 })} goToPage={1}>
        &#171;
      </Button>
      <Button
        className={cx("button", { invisible: page === 1 })}
        goToPage={page - 1}
      >
        &#8249;
      </Button>
      {shownPage.map((_page, i) => {
        return _page === "more" ? (
          <div className="d-none d-sm-block">...</div>
        ) : (
          <div
            className={cx(
              "button-wrapper justify-content-center align-items-center mx-1 mt-1",
              {
                "active rounded-circle d-flex": page === _page,
                "d-none d-sm-flex": _page != page,
              }
            )}
          >
            <Button className="button" goToPage={_page}>
              {_page}
            </Button>
          </div>
        );
      })}
      <Button
        className={cx("button", { invisible: page === totalPage })}
        goToPage={page + 1}
      >
        &#8250;
      </Button>
      <Button
        className={cx("button", { invisible: page === totalPage })}
        goToPage={totalPage}
      >
        &#187;
      </Button>
    </div>
  );
};

export default Pagination;
